<template>
  <div class="selection-list" v-if="selectionList">
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :immediate-check="false" :offset="1">
      <div v-for="(item,index) in selectionList" :key="index" class="special" @click="navToDetail(item.id)">
        <img :src="item.picUrl">
        <div class="special-title">{{item.title}}</div>
        <div class="sub-title"><span class="special-sub">￥{{item.price}}</span>元起&nbsp;|&nbsp;{{item.subtitle}}</div>

      </div>
    </van-list>

    <!-- <van-pagination class="page-size" v-model="currentPage" :page-count="selectionList.count" mode="simple" /> -->
  </div>
</template>

<script>
// import itemInfo from "@/components/itemInfo";

import { topicList } from "@/api/index";
import { Dialog } from "vant";

export default {
  name: "featureSelection",
  data() {
    return {
      selectionList: [],
      currentPage: 1,
      finished: false,
      loading: false,
      data: {
        page: 1,
        size: 10,
      },
    };
  },
  mounted() {
    this.gettopicList(this.data);
  },
  methods: {
    gettopicList(data) {
      topicList(data).then((res) => {
        if (res.data.errno == 0) {
          console.log(res.data.data.data);
          // this.selectionList = res.data.data;
          let newOfRes = JSON.parse(JSON.stringify(res.data.data));
          this.selectionList = this.selectionList.concat(newOfRes.data);
          console.log(this.selectionList);
          this.loading = false;
          // // 数据全部加载完成
          if (this.selectionList.length == newOfRes.count) {
            this.finished = true;
          }
        } else {
          Dialog.alert({
            title: "提示",
            message: res.data.errmsg,
          });
        }
      });
    },
    onLoad() {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      setTimeout(() => {
        this.data.page += 1;
        console.log(this.data);
        this.gettopicList(this.data);
        // 加载状态结束
        this.loading = false;
      }, 1000);
    },
    navToDetail(id) {
      this.$router.push({
        path: "/featureDetail",
        query: {
          id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.selection-list {
  height: 100%;
  background: #f4f4f4;
  overflow-y: scroll;
  box-sizing: border-box;
  overflow-x: hidden;
  padding: 1.6rem 1.6rem 5rem;
  .special {
    width: 100%;
    background: #fff;
    height: 24.1rem;
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 1.2rem;
    box-shadow: 0 5px 16px 0 rgba(0, 0, 0, 0.05);
    .special-title {
      font-family: PingFangSC-Semibold;
      font-size: 1.4rem;
      color: #424242;
      letter-spacing: 0;
      line-height: 1.4rem;
      text-align: left;
      margin-top: 1.6rem;
      margin-bottom: 0.9rem;

      padding-left: 1rem;
      box-sizing: border-box;
    }
    .sub-title {
      font-family: PingFangSC-Regular;
      font-size: 1.2rem;
      color: #6f6f6f;
      letter-spacing: 0;
      line-height: 1.2rem;
      text-align: left;
      padding-left: 1rem;
      box-sizing: border-box;

      .special-sub {
        font-family: PingFangSC-Semibold;
        font-size: 1.2rem;
        color: #d6be93;
        letter-spacing: 0;
        line-height: 1.2rem;
      }
    }
    img {
      width: auto;
      margin: 0 auto;
      height: 17.3rem;
    }
  }
  .page-size {
    margin-top: 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/index/featureSelection.vue